import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Icon } from '@uhg-abyss/web/ui/Icon';

export const PageContainer = styled(Flex, {
  background: '#FAFCFF',
  height: '512px',
  gap: '12px',
  alignItems: 'center',
  alignContent: 'center',
  flexDirection: 'column',
  paddingBottom: '$md',
  '@media (max-width: 464px)': {
    height: '263px',
    paddingTop: '$md',
    paddingLeft: '$lg',
    alignContent: 'flex-start',
    flexDirection: 'row-reverse',
  },
});

export const IconContainer = styled('div', {
  height: '208px',
  width: '287px',
  overflow: 'hidden',
  position: 'relative',
  '@media (max-width: 464px)': {
    height: '176px',
    width: '129px',
  },
});

export const PageContent = styled(Flex, {
  alignContent: 'center',
  alignItems: 'center',
  flex: 1,
  flexDirection: 'column',
  '@media (max-width: 464px)': {
    alignItems: 'flex-start',
    alignContent: 'flex-start',
  },
});

export const PuzzleIcon = styled(Icon, {
  position: 'absolute',
  top: '-81px',
  height: '287px! important',
  '@media (max-width: 464px)': {
    right: '-46px',
    top: 'unset',
    width: '175px ! important',
    height: '176px! important',
  },
});
